<div class="page-content">
  <!-- KPI Grid (6 cards) -->
  <div class="kpi-grid">
    <div *ngFor="let kpi of kpis" class="kpi-card">
      <div class="metric-icon" [ngClass]="kpi.tone">
        <svg *ngIf="kpi.iconType === 'users'" width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>

        <svg *ngIf="kpi.iconType === 'check'" width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
          <polyline points="22 4 12 14.01 9 11.01"/>
        </svg>

        <svg *ngIf="kpi.iconType === 'briefcase'" width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M12 12h.01"/>
          <path d="M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/>
          <path d="M22 13a18.15 18.15 0 0 1-20 0"/>
          <rect width="20" height="14" x="2" y="6" rx="2"/>
        </svg>

        <svg *ngIf="kpi.iconType === 'clipboard'" width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect width="8" height="4" x="8" y="2" rx="1" ry="1"/>
          <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>
          <path d="m9 14 2 2 4-4"/>
        </svg>

        <svg *ngIf="kpi.iconType === 'calendar'" width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect width="18" height="18" x="3" y="4" rx="2" ry="2"/>
          <line x1="16" x2="16" y1="2" y2="6"/>
          <line x1="8" x2="8" y1="2" y2="6"/>
          <line x1="3" x2="21" y1="10" y2="10"/>
        </svg>

        <svg *ngIf="kpi.iconType === 'building'" width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect width="16" height="20" x="4" y="2" rx="2" ry="2"/>
          <path d="M9 22v-4h6v4"/>
          <path d="M8 6h.01"/>
          <path d="M16 6h.01"/>
          <path d="M8 10h.01"/>
          <path d="M16 10h.01"/>
          <path d="M8 14h.01"/>
          <path d="M16 14h.01"/>
        </svg>
      </div>

      <div class="metric-copy">
        <span>{{ kpi.label }}</span>
        <strong>{{ kpi.value }}</strong>
        <small>{{ kpi.note }}</small>
      </div>
    </div>
  </div>

  <!-- Two Column Section -->
  <div class="two-col top-panels">
    <!-- Active Opportunities Panel -->
    <section class="panel">
      <div class="panel-heading">
        <h2>Active Opportunities</h2>
        <button type="button" class="text-action" (click)="viewAllJobs.emit()">
          View all jobs
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>
        </button>
      </div>

      <div class="opportunity-list">
        <button
          *ngFor="let job of jobs"
          type="button"
          class="opportunity-row"
          (click)="onJobClick(job)">
          <div class="company-logo table-logo" [class.has-img]="job.company_logo_url">
            <img *ngIf="job.company_logo_url" [src]="job.company_logo_url" alt="" />
            <ng-container *ngIf="!job.company_logo_url">{{ job.company_name.charAt(0) }}</ng-container>
          </div>
          <div class="opportunity-name">
            <strong>{{ job.company_name }}</strong>
            <span>{{ job.role }}</span>
          </div>
          <small>{{ job.applicants }} Applicants</small>
          <!-- Not currently shown — status is hidden site-wide on job listings
          for now (see repository/college_portal_jobs.py list_jobs), so this
          always comes back null.
          <em [ngClass]="job.status === 'Applications Open' ? 'open' : 'ongoing'">{{ job.status }}</em>
          -->
        </button>
        <div *ngIf="!isLoadingJobs && jobs.length === 0" class="empty-cell">No active opportunities right now.</div>
      </div>

      <button type="button" class="more-link" *ngIf="moreJobsCount > 0" (click)="viewAllJobs.emit()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
        {{ moreJobsCount }} more active jobs
      </button>
    </section>

    <!-- Not currently shown — Needs Attention panel.
    <section class="panel">
      <div class="panel-heading">
        <h2>Needs Attention</h2>
        <button type="button" class="text-action" (click)="onAttentionClick('Profiles Incomplete')">
          View all
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>
        </button>
      </div>

      <div class="attention-list">
        <button
          *ngFor="let item of attentionItems"
          type="button"
          class="attention-row"
          (click)="onAttentionClick(item.category)">
          <div class="attention-icon" [ngClass]="item.tone">
            <svg *ngIf="item.iconType === 'user'" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
            <svg *ngIf="item.iconType === 'file'" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/><polyline points="14 2 14 8 20 8"/></svg>
            <svg *ngIf="item.iconType === 'building'" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect width="16" height="20" x="4" y="2" rx="2" ry="2"/><path d="M9 22v-4h6v4"/></svg>
          </div>
          <strong>{{ item.value }}</strong>
          <span>{{ item.label }}</span>
          <svg class="chev" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>
        </button>
      </div>
    </section>
    -->
  </div>

  <!-- Not currently shown — Placement Rate by Department chart.
  <section class="panel">
    <div class="panel-heading">
      <h2>Placement Rate by Department</h2>
      <button type="button" class="text-action" (click)="onExportReport()">
        Export
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>
      </button>
    </div>

    <div class="bar-chart">
      <div *ngFor="let dept of departmentRates" class="bar-group">
        <strong>{{ dept.value }}%</strong>
        <div class="bar" [style.height.%]="dept.value"></div>
        <span>{{ dept.name }}</span>
      </div>
    </div>

    <p class="chart-note">Placement rate = Selected Students / Eligible Students</p>
    <button type="button" class="chart-export" (click)="onExportReport()">
      Export department report
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
    </button>
  </section>
  -->

  <!-- Not currently shown — Recent Activity strip.
  <section class="panel">
    <div class="panel-heading">
      <h2>Recent Activity</h2>
      <button type="button" class="text-action">
        View all
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>
      </button>
    </div>

    <div class="activity-strip">
      <div *ngFor="let act of activities; let i = index" class="activity-item">
        <div class="activity-icon" [ngClass]="'a' + act.typeIndex">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
          </svg>
        </div>
        <div class="activity-copy">
          <strong>{{ act.text }}</strong>
          <span>{{ act.time }}</span>
        </div>
      </div>
    </div>
  </section>
  -->
</div>
